import { ReviewProps } from '@/interfaces/models/review';
import PlaceDate from '@/utils/placeDate';
import Image from '@/models/image';

export default class Review {
  public createdAt: number;
  public evaluation: number;
  public id: string;
  public image: Image = new Image();
  public isRead: boolean = false;
  public text: string;

  public constructor(reviewProps: ReviewProps) {
    this.createdAt = reviewProps.createdAt;
    this.evaluation = reviewProps.evaluation;
    this.id = reviewProps.id;

    if (reviewProps.image) {
      this.image = new Image(reviewProps.image);
    }

    this.isRead = reviewProps.isRead;
    this.text = reviewProps.text;
  }

  get date(): PlaceDate {
    return new PlaceDate(this.createdAt);
  }

  get evaluationPercent() {
    return this.evaluation / 10 * 100;
  }

  get humanDate(): string {
    return `${this.date.getHumanDateString()}, ${this.date.getHumanHours()}:${this.date.getHumanMinutes()}`;
  }
}
